/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { memo } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Link } from 'react-router';

import { Grid, Typography } from '@mui/material';

import scalefieldLogo from '../../../../assets/images/scalefield_logo.svg';
import { Namespaces } from '../../../../i18n';
import { createHeaderSectionStyles } from './HeaderSection.styles';

export const HeaderSection = memo(() => {
  const classes = createHeaderSectionStyles();
  const { t } = useTranslation(Namespaces.About);

  return (
    <Grid item md={12} className={classes.root}>
      <div className={classes.logo}>
        <Link to="/">
          <img src={scalefieldLogo} alt="Logo" className={classes.imageLogo} />
        </Link>
      </div>
      <div className={classes.container}>
        <Grid item lg={6} md={9}>
          <Typography variant="h1" classes={{ root: classes.h1 }}>
            {t('header.title')}
          </Typography>
          <Typography variant="h2" classes={{ root: classes.h2 }}>
            {t('header.subtitle')}
          </Typography>
          <div className={classes.location}>
            <Trans>{t('header.located')}</Trans>
          </div>
          <Typography variant="body1" classes={{ root: classes.body2 }}>
            {t('header.description')}
          </Typography>
        </Grid>
      </div>
    </Grid>
  );
});
